/** Shared active-field key — sync snapshot for per-field subscriptions. */
let activeEditorKeySnapshot = null
const activeEditorListeners = new Set()

export function getActiveEditorKey() {
  return activeEditorKeySnapshot
}

export function subscribeActiveEditor(listener) {
  activeEditorListeners.add(listener)
  return () => activeEditorListeners.delete(listener)
}

export function publishActiveEditorKey(next) {
  if (Object.is(activeEditorKeySnapshot, next)) return
  activeEditorKeySnapshot = next
  activeEditorListeners.forEach((listener) => listener())
}
